import axios from "axios";
import * as actionType from "../../constant/actionType";
export const MarkTaskAsRead = (APIData) => async (dispatch) => {
  try {
    // dispatch(fetchData());
    const response = await axios({
      method: "patch",
      data: APIData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/worker/MarkTaskAsRead`,
    });
    return response.data;
  } catch (error) {
    return error.message;
  }
};
